export const spaceTypes = {
    // Get single space
    FETCH_SINGLE_SPACE_REQUEST: "FETCH_SINGLE_SPACE_REQUEST",
    FETCH_SINGLE_SPACE_SUCCESS: "FETCH_SINGLE_SPACE_SUCCESS",
    FETCH_SINGLE_SPACE_FAILURE: "FETCH_SINGLE_SPACE_FAILURE",

    // Get spaces list
    FETCH_SPACES_REQUEST: "FETCH_SPACES_REQUEST",
    FETCH_SPACES_SUCCESS: "FETCH_SPACES_SUCCESS",
    FETCH_SPACES_FAILURE: "FETCH_SPACES_FAILURE",
    REMOVE_SPACE_FROM_LIST: "REMOVE_SPACE_FROM_LIST",

    // Create space
    CREATE_SPACE_REQUEST: "CREATE_SPACE_REQUEST",
    CREATE_SPACE_SUCCESS: "CREATE_SPACE_SUCCESS",
    CREATE_SPACE_FAILURE: "CREATE_SPACE_FAILURE",

    // Update space
    UPDATE_SPACE_REQUEST: "UPDATE_SPACE_REQUEST",
    UPDATE_SPACE_SUCCESS: "UPDATE_SPACE_SUCCESS",
    UPDATE_SPACE_FAILURE: "UPDATE_SPACE_FAILURE",

    // Delete space
    DELETE_SPACE_REQUEST: "DELETE_SPACE_REQUEST",
    DELETE_SPACE_SUCCESS: "DELETE_SPACE_SUCCESS",
    DELETE_SPACE_FAILURE: "DELETE_SPACE_FAILURE",

    // Pin space
    PIN_SPACE_REQUEST: "PIN_SPACE_REQUEST",
    PIN_SPACE_SUCCESS: "PIN_SPACE_SUCCESS",
    PIN_SPACE_FAILURE: "PIN_SPACE_FAILURE",

    // Unpin space
    UNPIN_SPACE_REQUEST: "UNPIN_SPACE_REQUEST",
    UNPIN_SPACE_SUCCESS: "UNPIN_SPACE_SUCCESS",
    UNPIN_SPACE_FAILURE: "UNPIN_SPACE_FAILURE",

    // Archive space
    ARCHIVE_SPACE_REQUEST: "ARCHIVE_SPACE_REQUEST",
    ARCHIVE_SPACE_SUCCESS: "ARCHIVE_SPACE_SUCCESS",
    ARCHIVE_SPACE_FAILURE: "ARCHIVE_SPACE_FAILURE",

    // Unarchive space
    UNARCHIVE_SPACE_REQUEST: "UNARCHIVE_SPACE_REQUEST",
    UNARCHIVE_SPACE_SUCCESS: "UNARCHIVE_SPACE_SUCCESS",
    UNARCHIVE_SPACE_FAILURE: "UNARCHIVE_SPACE_FAILURE",

    // Add members to space
    ADD_SPACE_MEMBERS_REQUEST: "ADD_SPACE_MEMBERS_REQUEST",
    ADD_SPACE_MEMBERS_SUCCESS: "ADD_SPACE_MEMBERS_SUCCESS",
    ADD_SPACE_MEMBERS_FAILURE: "ADD_SPACE_MEMBERS_FAILURE",

    // Remove member from space
    REMOVE_SPACE_MEMBER_REQUEST: "REMOVE_SPACE_MEMBER_REQUEST",
    REMOVE_SPACE_MEMBER_SUCCESS: "REMOVE_SPACE_MEMBER_SUCCESS",
    REMOVE_SPACE_MEMBER_FAILURE: "REMOVE_SPACE_MEMBER_FAILURE",

    // Add guests to space
    ADD_SPACE_GUESTS_REQUEST: "ADD_SPACE_GUESTS_REQUEST",
    ADD_SPACE_GUESTS_SUCCESS: "ADD_SPACE_GUESTS_SUCCESS",
    ADD_SPACE_GUESTS_FAILURE: "ADD_SPACE_GUESTS_FAILURE",

    // Remove guest from space
    REMOVE_SPACE_GUEST_REQUEST: "REMOVE_SPACE_GUEST_REQUEST",
    REMOVE_SPACE_GUEST_SUCCESS: "REMOVE_SPACE_GUEST_SUCCESS",
    REMOVE_SPACE_GUEST_FAILURE: "REMOVE_SPACE_GUEST_FAILURE",

    // Space guest accepts invite
    SPACE_GUEST_ACCEPT_REQUEST: "SPACE_GUEST_ACCEPT_REQUEST",
    SPACE_GUEST_ACCEPT_SUCCESS: "SPACE_GUEST_ACCEPT_SUCCESS",
    SPACE_GUEST_ACCEPT_FAILURE: "SPACE_GUEST_ACCEPT_FAILURE",

    // Space guest login
    SPACE_GUEST_LOGIN_REQUEST: "SPACE_GUEST_LOGIN_REQUEST",
    SPACE_GUEST_LOGIN_SUCCESS: "SPACE_GUEST_LOGIN_SUCCESS",
    SPACE_GUEST_LOGIN_FAILURE: "SPACE_GUEST_LOGIN_FAILURE",

    // Space guest token verification
    SPACE_GUEST_TOKEN_VERIFY_REQUEST: "SPACE_GUEST_TOKEN_VERIFY_REQUEST",
    SPACE_GUEST_TOKEN_VERIFY_SUCCESS: "SPACE_GUEST_TOKEN_VERIFY_SUCCESS",
    SPACE_GUEST_TOKEN_VERIFY_FAILURE: "SPACE_GUEST_TOKEN_VERIFY_FAILURE",

    // Get space guest invite preview
    GET_SPACE_GUEST_INVITE_PREVIEW_REQUEST: "GET_SPACE_GUEST_INVITE_PREVIEW_REQUEST",
    GET_SPACE_GUEST_INVITE_PREVIEW_SUCCESS: "GET_SPACE_GUEST_INVITE_PREVIEW_SUCCESS",
    GET_SPACE_GUEST_INVITE_PREVIEW_FAILURE: "GET_SPACE_GUEST_INVITE_PREVIEW_FAILURE",

    // Get space guest brands
    GET_SPACE_GUEST_BRANDS_REQUEST: "GET_SPACE_GUEST_BRANDS_REQUEST",
    GET_SPACE_GUEST_BRANDS_SUCCESS: "GET_SPACE_GUEST_BRANDS_SUCCESS",
    GET_SPACE_GUEST_BRANDS_FAILURE: "GET_SPACE_GUEST_BRANDS_FAILURE",

    // Leave space
    LEAVE_SPACE_REQUEST: "LEAVE_SPACE_REQUEST",
    LEAVE_SPACE_SUCCESS: "LEAVE_SPACE_SUCCESS",
    LEAVE_SPACE_FAILURE: "LEAVE_SPACE_FAILURE",

    // Space Messages
    // Get space messages
    FETCH_SPACE_MESSAGES_REQUEST: "FETCH_SPACE_MESSAGES_REQUEST",
    FETCH_SPACE_MESSAGES_SUCCESS: "FETCH_SPACE_MESSAGES_SUCCESS",
    FETCH_SPACE_MESSAGES_FAILURE: "FETCH_SPACE_MESSAGES_FAILURE",

    // Send space message
    SEND_SPACE_MESSAGE_REQUEST: "SEND_SPACE_MESSAGE_REQUEST",
    SEND_SPACE_MESSAGE_SUCCESS: "SEND_SPACE_MESSAGE_SUCCESS",
    SEND_SPACE_MESSAGE_FAILURE: "SEND_SPACE_MESSAGE_FAILURE",

    // Pin space message
    PIN_SPACE_MESSAGE_REQUEST: "PIN_SPACE_MESSAGE_REQUEST",
    PIN_SPACE_MESSAGE_SUCCESS: "PIN_SPACE_MESSAGE_SUCCESS",
    PIN_SPACE_MESSAGE_FAILURE: "PIN_SPACE_MESSAGE_FAILURE",

    // Unpin space message
    UNPIN_SPACE_MESSAGE_REQUEST: "UNPIN_SPACE_MESSAGE_REQUEST",
    UNPIN_SPACE_MESSAGE_SUCCESS: "UNPIN_SPACE_MESSAGE_SUCCESS",
    UNPIN_SPACE_MESSAGE_FAILURE: "UNPIN_SPACE_MESSAGE_FAILURE",

    // Edit space message
    EDIT_SPACE_MESSAGE_REQUEST: "EDIT_SPACE_MESSAGE_REQUEST",
    EDIT_SPACE_MESSAGE_SUCCESS: "EDIT_SPACE_MESSAGE_SUCCESS",
    EDIT_SPACE_MESSAGE_FAILURE: "EDIT_SPACE_MESSAGE_FAILURE",

    // Delete space message
    DELETE_SPACE_MESSAGE_REQUEST: "DELETE_SPACE_MESSAGE_REQUEST",
    DELETE_SPACE_MESSAGE_SUCCESS: "DELETE_SPACE_MESSAGE_SUCCESS",
    DELETE_SPACE_MESSAGE_FAILURE: "DELETE_SPACE_MESSAGE_FAILURE",
    CREATE_SPACE_FILE_REQUEST: "CREATE_SPACE_FILE_REQUEST",
    CREATE_SPACE_FILE_SUCCESS: "CREATE_SPACE_FILE_SUCCESS",
    CREATE_SPACE_FILE_FAILURE: "CREATE_SPACE_FILE_FAILURE",
    GET_SPACE_FILES_REQUEST: "GET_SPACE_FILES_REQUEST",
    GET_SPACE_FILES_SUCCESS: "GET_SPACE_FILES_SUCCESS",
    GET_SPACE_FILES_FAILURE: "GET_SPACE_FILES_FAILURE",
    DELETE_SPACE_FILE_REQUEST: "DELETE_SPACE_FILE_REQUEST",
    DELETE_SPACE_FILE_SUCCESS: "DELETE_SPACE_FILE_SUCCESS",
    DELETE_SPACE_FILE_FAILURE: "DELETE_SPACE_FILE_FAILURE",
    GET_SINGLE_SPACE_FILE_REQUEST: "GET_SINGLE_SPACE_FILE_REQUEST",
    GET_SINGLE_SPACE_FILE_SUCCESS: "GET_SINGLE_SPACE_FILE_SUCCESS",
    GET_SINGLE_SPACE_FILE_FAILURE: "GET_SINGLE_SPACE_FILE_FAILURE",
    CREATE_SPACE_NOTE_REQUEST: "CREATE_SPACE_NOTE_REQUEST",
    CREATE_SPACE_NOTE_SUCCESS: "CREATE_SPACE_NOTE_SUCCESS",
    CREATE_SPACE_NOTE_FAILURE: "CREATE_SPACE_NOTE_FAILURE",
    FETCH_SPACE_NOTES_REQUEST: "FETCH_SPACE_NOTES_REQUEST",
    FETCH_SPACE_NOTES_SUCCESS: "FETCH_SPACE_NOTES_SUCCESS",
    FETCH_SPACE_NOTES_FAILURE: "FETCH_SPACE_NOTES_FAILURE",
    FETCH_SINGLE_SPACE_NOTE_REQUEST: "FETCH_SINGLE_SPACE_NOTE_REQUEST",
    FETCH_SINGLE_SPACE_NOTE_SUCCESS: "FETCH_SINGLE_SPACE_NOTE_SUCCESS",
    FETCH_SINGLE_SPACE_NOTE_FAILURE: "FETCH_SINGLE_SPACE_NOTE_FAILURE",
    DELETE_SPACE_NOTE_REQUEST: "DELETE_SPACE_NOTE_REQUEST",
    DELETE_SPACE_NOTE_SUCCESS: "DELETE_SPACE_NOTE_SUCCESS",
    DELETE_SPACE_NOTE_FAILURE: "DELETE_SPACE_NOTE_FAILURE",
    UPDATE_SPACE_NOTE_REQUEST: "UPDATE_SPACE_NOTE_REQUEST",
    UPDATE_SPACE_NOTE_SUCCESS: "UPDATE_SPACE_NOTE_SUCCESS",
    UPDATE_SPACE_NOTE_FAILURE: "UPDATE_SPACE_NOTE_FAILURE",
    PIN_SPACE_NOTE_REQUEST: "PIN_SPACE_NOTE_REQUEST",
    PIN_SPACE_NOTE_SUCCESS: "PIN_SPACE_NOTE_SUCCESS",
    PIN_SPACE_NOTE_FAILURE: "PIN_SPACE_NOTE_FAILURE",
    UNPIN_SPACE_NOTE_REQUEST: "UNPIN_SPACE_NOTE_REQUEST",
    UNPIN_SPACE_NOTE_SUCCESS: "UNPIN_SPACE_NOTE_SUCCESS",
    UNPIN_SPACE_NOTE_FAILURE: "UNPIN_SPACE_NOTE_FAILURE",

    // Reset actions
    RESET_FETCH_SINGLE_SPACE: "RESET_FETCH_SINGLE_SPACE",
    RESET_FETCH_SPACES: "RESET_FETCH_SPACES",
    RESET_CREATE_SPACE: "RESET_CREATE_SPACE",
    RESET_UPDATE_SPACE: "RESET_UPDATE_SPACE",
    RESET_DELETE_SPACE: "RESET_DELETE_SPACE",
    RESET_PIN_SPACE: "RESET_PIN_SPACE",
    RESET_UNPIN_SPACE: "RESET_UNPIN_SPACE",
    RESET_ARCHIVE_SPACE: "RESET_ARCHIVE_SPACE",
    RESET_UNARCHIVE_SPACE: "RESET_UNARCHIVE_SPACE",
    RESET_ADD_SPACE_MEMBERS: "RESET_ADD_SPACE_MEMBERS",
    RESET_REMOVE_SPACE_MEMBER: "RESET_REMOVE_SPACE_MEMBER",
    RESET_ADD_SPACE_GUESTS: "RESET_ADD_SPACE_GUESTS",
    RESET_REMOVE_SPACE_GUEST: "RESET_REMOVE_SPACE_GUEST",
    RESET_SPACE_GUEST_ACCEPT: "RESET_SPACE_GUEST_ACCEPT",
    RESET_SPACE_GUEST_LOGIN: "RESET_SPACE_GUEST_LOGIN",
    RESET_SPACE_GUEST_TOKEN_VERIFY: "RESET_SPACE_GUEST_TOKEN_VERIFY",
    RESET_GET_SPACE_GUEST_INVITE_PREVIEW: "RESET_GET_SPACE_GUEST_INVITE_PREVIEW",
    RESET_GET_SPACE_GUEST_BRANDS: "RESET_GET_SPACE_GUEST_BRANDS",
    RESET_LEAVE_SPACE: "RESET_LEAVE_SPACE",
    RESET_FETCH_SPACE_MESSAGES: "RESET_FETCH_SPACE_MESSAGES",
    RESET_SEND_SPACE_MESSAGE: "RESET_SEND_SPACE_MESSAGE",
    RESET_PIN_SPACE_MESSAGE: "RESET_PIN_SPACE_MESSAGE",
    RESET_UNPIN_SPACE_MESSAGE: "RESET_UNPIN_SPACE_MESSAGE",
    RESET_EDIT_SPACE_MESSAGE: "RESET_EDIT_SPACE_MESSAGE",
    RESET_DELETE_SPACE_MESSAGE: "RESET_DELETE_SPACE_MESSAGE",

    // Space Tasks
    FETCH_SPACE_TASKS_REQUEST: "FETCH_SPACE_TASKS_REQUEST",
    FETCH_SPACE_TASKS_SUCCESS: "FETCH_SPACE_TASKS_SUCCESS",
    FETCH_SPACE_TASKS_FAILURE: "FETCH_SPACE_TASKS_FAILURE",

    FETCH_SINGLE_SPACE_TASK_REQUEST: "FETCH_SINGLE_SPACE_TASK_REQUEST",
    FETCH_SINGLE_SPACE_TASK_SUCCESS: "FETCH_SINGLE_SPACE_TASK_SUCCESS",
    FETCH_SINGLE_SPACE_TASK_FAILURE: "FETCH_SINGLE_SPACE_TASK_FAILURE",

    CREATE_SPACE_TASK_REQUEST: "CREATE_SPACE_TASK_REQUEST",
    CREATE_SPACE_TASK_SUCCESS: "CREATE_SPACE_TASK_SUCCESS",
    CREATE_SPACE_TASK_FAILURE: "CREATE_SPACE_TASK_FAILURE",

    UPDATE_SPACE_TASK_REQUEST: "UPDATE_SPACE_TASK_REQUEST",
    UPDATE_SPACE_TASK_SUCCESS: "UPDATE_SPACE_TASK_SUCCESS",
    UPDATE_SPACE_TASK_FAILURE: "UPDATE_SPACE_TASK_FAILURE",

    DELETE_SPACE_TASK_REQUEST: "DELETE_SPACE_TASK_REQUEST",
    DELETE_SPACE_TASK_SUCCESS: "DELETE_SPACE_TASK_SUCCESS",
    DELETE_SPACE_TASK_FAILURE: "DELETE_SPACE_TASK_FAILURE",

    RESET_FETCH_SPACE_TASKS: "RESET_FETCH_SPACE_TASKS",
    RESET_FETCH_SINGLE_SPACE_TASK: "RESET_FETCH_SINGLE_SPACE_TASK",
    RESET_CREATE_SPACE_TASK: "RESET_CREATE_SPACE_TASK",
    RESET_UPDATE_SPACE_TASK: "RESET_UPDATE_SPACE_TASK",
    RESET_DELETE_SPACE_TASK: "RESET_DELETE_SPACE_TASK",

    FETCH_SPACE_TASKS_RUNS_REQUEST: "FETCH_SPACE_TASKS_RUNS_REQUEST",
    FETCH_SPACE_TASKS_RUNS_SUCCESS: "FETCH_SPACE_TASKS_RUNS_SUCCESS",
    FETCH_SPACE_TASKS_RUNS_FAILURE: "FETCH_SPACE_TASKS_RUNS_FAILURE",
    FETCH_SPACE_UNREAD_COUNT_REQUEST: "FETCH_SPACE_UNREAD_COUNT_REQUEST",
    FETCH_SPACE_UNREAD_COUNT_SUCCESS: "FETCH_SPACE_UNREAD_COUNT_SUCCESS",
    FETCH_SPACE_UNREAD_COUNT_FAILURE: "FETCH_SPACE_UNREAD_COUNT_FAILURE",
};

export interface CreateSpacePayload {
    name: string;
    description: string;
    memberIds: string[];
    guestEmails: string[];
}

export interface UpdateSpacePayload {
    name?: string;
    description?: string;
}

export interface SpaceFilters {
    search?: string;
    status?: string;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortDirection?: "asc" | "desc";
    archived?: boolean;
    brand?: string;
}

export interface AddSpaceMembersPayload {
    members: string[];
}

export interface AddSpaceGuestsPayload {
    guests: string[];
}

export interface SpaceGuestAcceptPayload {
    firstName: string;
    lastName: string;
    role: string;
    token: string;
}

export interface SpaceGuestLoginPayload {
    email: string;
}

export interface SpaceGuestTokenVerifyPayload {
    token: string;
}

export interface LdbUser {
    _id: string;
    profile: {
        avatar: string;
        businessName: string;
    };
    role: string;
    email: string;
    brandName: string;
    firstName: string;
    fullName: string;
    lastName: string;
}

export interface Guest {
    _id: string;
    email: string;
    firstName: string;
    lastName: string;
    isOwner: boolean;
    role: string;
}

export interface SpaceMember {
    ldb: LdbUser;
    ldbId: string;
    invitedAt: string | null;
    pinnedAt: string | null;
    createdAt: string;
    updatedAt: string;
    isOwner: boolean;
    isPinned: boolean;
    type: "member";
}

export interface SpaceGuest {
    guest: Guest;
    guestId: string;
    pinnedAt: string | null;
    invitedAt: string;
    inviteAcceptedAt: string | null;
    createdAt: string;
    updatedAt: string;
    isPinned: boolean;
    hasAcceptedInvite: boolean;
    type: "guest";
    firstName?: string;
    lastName?: string;
    role?: string;
}

export interface Space {
    _id: string;
    name: string;
    description: string;
    ldb: LdbUser;
    ldbId: string;
    deletedAt: string | null;
    archivedAt: string | null;
    createdAt: string;
    updatedAt: string;
    __v: number;
    members: (SpaceMember | SpaceGuest)[];
    isDeleted: boolean;
    isArchived: boolean;
    color: string;
    isPinned: boolean;
}

export interface GetSpacesResponse {
    spaces: Space[];
    total: number;
    pagination: {
        current: number;
        next: number;
        perPage: number;
        number_of_pages: number;
    };
}

// Space Message Types
export interface SpaceMessageMention {
    kind: "user" | "synth" | "file" | "note" | "entity";
    user?: {
        ldbId: string;
    };
    file?: {
        fileId: string;
    };
    note?: {
        noteId: string;
    };
    entity?: {
        entityType: string;
        entityId: string;
    };
}

export interface SpaceMessageAttachment {
    url: string;
    path: string;
    filename: string;
    fileType: string;
}

// Space Message Payloads
export interface SendSpaceMessagePayload {
    spaceId: string;
    message: string;
    mentions?: SpaceMessageMention[];
    attachments?: SpaceMessageAttachment[];
}

export interface GetSpaceMessagesPayload {
    spaceId: string;
    page?: number;
    limit?: number;
    sortBy?: string;
    sortDirection?: "asc" | "desc";
}

export interface PinSpaceMessagePayload {
    spaceId: string;
    messageId: string;
}

export interface EditSpaceMessagePayload {
    spaceId: string;
    messageId: string;
    message: string;
}

export interface DeleteSpaceMessagePayload {
    spaceId: string;
    messageId: string;
}

export interface GetSpaceMessagesResponse {
    messages: any[]; // SpaceMessage[] - will be imported from types/spaceTypes
    total: number;
    pagination: {
        current: number;
        next: number;
        perPage: number;
        number_of_pages: number;
    };
}

// Space Guest Invite Preview Types
export interface SpaceGuestInvitePreviewBrand {
    _id: string;
    name: string;
    avatar: string;
}

export interface SpaceGuestInvitePreviewInvitedBy {
    _id: string;
    name: string;
    avatar: string;
}

export interface SpaceGuestInvitePreviewData {
    _id: string;
    name: string;
    description: string;
    brand: SpaceGuestInvitePreviewBrand;
    invitedBy: SpaceGuestInvitePreviewInvitedBy;
}

// Space Guest Brands Types
export interface SpaceGuestBrand {
    _id: string;
    brandName: string;
    avatar: string;
}

export interface GetSpaceGuestBrandsResponse {
    brands: SpaceGuestBrand[];
    total: number;
}

// Space Task Types
export interface SpaceTaskAssignee {
    kind: "synth" | "user";
    ldbId?: string;
    guestId?: string;
}

export interface SpaceTaskRecurrence {
    frequency: SpaceTaskFrequencyEnum;
    endCondition: SpaceTaskEndConditionEnum;
    startAt: string; // ISO date string
    endAt: string; // ISO date string
    endAfter?: string; // ISO date string
    endBy?: number; // number of occurrences
}

export interface SpaceTaskSchedule {
    type?: TaskScheduleTypeEnum;
    startAt?: string; // ISO date string
    endAt?: string; // ISO date string
    recurrence?: SpaceTaskRecurrence;
}

export interface CreateSpaceTaskPayload {
    name: string;
    description: string;
    status: SpaceTaskStatusEnum;
    priority: SpaceTaskPriorityEnum;
    schedule: {
        type: TaskScheduleTypeEnum;
        startAt: Date;
        endAt?: Date;
        recurrence?: {
            frequency: SpaceTaskFrequencyEnum;
            endCondition: SpaceTaskEndConditionEnum;
            endAt?: Date;
            endAfter?: number;
        };
    };
    assignees: {
        kind: SpaceTaskAssignedToKindEnum;
        ldbId?: string;
        guestId?: string;
    }[];
    reminderMethods: SpaceTaskReminderMethodEnum[];
}

export interface UpdateSpaceTaskPayload {
    name?: string;
    description?: string;
    status?: SpaceTaskStatusEnum;
    priority?: SpaceTaskPriorityEnum;
    schedule?: SpaceTaskSchedule;
    assignees?: SpaceTaskAssignee[];
    reminderMethods?: string[];
    parentTaskId?: string;
    taskType?: string;
}

export interface SpaceTaskFilters {
    page?: number;
    limit?: number;
    parentTaskId?: string;
    assignedToId?: string;
    priority?: SpaceTaskPriorityEnum | string;
    taskType?: TaskScheduleTypeEnum | string;
    search?: string;
    status?: SpaceTaskStatusEnum | string;
}

export interface SpaceTask {
    _id: string;
    name: string;
    description: string;
    space: string;
    spaceId: string;
    status: SpaceTaskStatusEnum;
    priority: SpaceTaskPriorityEnum;
    schedule: {
        type: TaskScheduleTypeEnum;
        startAt: Date;
        endAt?: Date;
        recurrence?: {
            frequency: SpaceTaskFrequencyEnum;
            endCondition: SpaceTaskEndConditionEnum;
            endAt?: Date;
            endAfter?: number;
        };
    };
    assignees: [
        {
            kind: SpaceTaskAssignedToKindEnum;
            ldbId?: string;
            guestId?: string;
            ldb?: {
                _id: string;
                firstName: string;
                fullName: string;
                lastName: string;
                email: string;
                profile: {
                    avatar: string;
                    businessName: string;
                };
            };
            guest?: {
                _id: string;
                email: string;
            };
        }
    ];
    reminderMethods: SpaceTaskReminderMethodEnum[];
    createdBy: {
        kind: SpaceTaskAssignedToKindEnum;
        guest?: {
            _id: string;
            email: string;
            firstName: string;
            lastName: string;
        };
        guestId?: string;
        ldb?: {
            _id: string;
            profile: {
                avatar: string;
                businessName: string;
            };
            brandName: string;
            firstName: string;
            fullName: string;
            lastName: string;
        };
        ldbId?: string;
    };
    createdAt: string;
    updatedAt: string;
    __v: number;
}

export interface GetSpaceTasksResponse {
    tasks: SpaceTask[];
    total: number;
    pagination: {
        current: number;
        next: number;
        perPage: number;
        number_of_pages: number;
    };
}

export enum TaskScheduleTypeEnum {
    oneTime = "one_time",
    recurring = "recurring",
}

export enum SpaceTaskFrequencyEnum {
    daily = "daily",
    weekly = "weekly",
    monthly = "monthly",
}

export enum SpaceTaskStatusEnum {
    todo = "todo",
    inProgress = "in_progress",
    completed = "completed",
    failed = "failed",
    canceled = "canceled",
}

export enum SpaceTaskPriorityEnum {
    low = "low",
    medium = "medium",
    high = "high",
}

export enum SpaceTaskReminderMethodEnum {
    email = "email",
    inAppNotification = "in_app_notification",
}

export enum SpaceTaskEndConditionEnum {
    none = "none",
    occurence = "occurence",
    date = "date",
}

export enum SpaceTaskAssignedToKindEnum {
    user = "user",
    synth = "synth",
}
